module.exports = __webpack_public_path__ + "img/zw-logo.e9dd3578.png";